import {
  Grid,
  Box,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel
} from '@chakra-ui/react'
import { FC, useEffect, useMemo } from 'react'

import useParametrizationProductSimilar from '@hook/parametrization/use-similar-product'
import useFilters from '@hook/shared/use-filters'
import useLayout from '@hook/shared/use-layout'
import useSessions from '@hook/shared/use-sessions'

import Layout from '@component/Layout'

import ParametrizationCurveDepedentsCD from './CurvesView/CurveDepedentsCD'
import ParametrizationCurveExecutation from './CurvesView/CurveExecucation'
import ParametrizationCurveStore from './CurvesView/CurveStore'
import ParametrizationCurveWeight from './CurvesView/CurveWeight'

const ParametrizationCurves: FC = () => {
  const { menuToggle } = useLayout()
  const { getFilters } = useFilters()
  const { getCenters } = useParametrizationProductSimilar()

  const { hasSessions } = useSessions()

  const height = useMemo(
    () =>
      menuToggle
        ? hasSessions
          ? 'calc(100vh - 30px)'
          : '100vh'
        : hasSessions
        ? 'calc(100vh - 160px)'
        : 'calc(100vh - 142px)',
    [menuToggle, hasSessions]
  )
  useEffect(() => {
    getCenters()

    // data?.length === 0 && getData()
    getFilters({})

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Layout title="Parametrização - Curvas">
      <Grid w="100vw" bg="white" h={height} templateColumns="100vw">
        <Box>
          <Tabs variant="soft-rounded" colorScheme="green">
            <TabList>
              <Tab>Curva - Peso</Tab>
              <Tab>Curva - Execução</Tab>
              <Tab>Dependentes CD</Tab>
              <Tab>Novas Lojas</Tab>
            </TabList>
            <TabPanels>
              <TabPanel>
                <ParametrizationCurveWeight />
              </TabPanel>
              <TabPanel>
                <ParametrizationCurveExecutation />
              </TabPanel>
              <TabPanel>
                <ParametrizationCurveDepedentsCD />
              </TabPanel>
              <TabPanel>
                <ParametrizationCurveStore />
              </TabPanel>
            </TabPanels>
          </Tabs>
        </Box>
      </Grid>
    </Layout>
  )
}

export default ParametrizationCurves
